import { off as a, on as d } from "./highrise632.mjs";
import { getEventTarget as c } from "./highrise1399.mjs";
const f = {
  mousemoveoutside: /* @__PURE__ */ new WeakMap(),
  clickoutside: /* @__PURE__ */ new WeakMap()
};
function l(t, n, s) {
  if (t === "mousemoveoutside") {
    const o = (e) => {
      n.contains(c(e)) || s(e);
    };
    return {
      mousemove: o,
      touchstart: o
    };
  } else if (t === "clickoutside") {
    let o = !1;
    const e = (u) => {
      o = !n.contains(c(u));
    }, r = (u) => {
      o && (n.contains(c(u)) || s(u));
    };
    return {
      mousedown: e,
      mouseup: r,
      touchstart: e,
      touchend: r
    };
  }
  return console.error(
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `[evtd/create-trap-handler]: name \`${t}\` is invalid. This could be a bug of evtd.`
  ), {};
}
function i(t, n, s) {
  const o = f[t];
  let e = o.get(n);
  e === void 0 && o.set(n, e = /* @__PURE__ */ new WeakMap());
  let r = e.get(s);
  return r === void 0 && e.set(s, r = l(t, n, s)), r;
}
function v(t, n, s, o) {
  if (t === "mousemoveoutside" || t === "clickoutside") {
    const e = i(t, n, s);
    return Object.keys(e).forEach((r) => {
      d(r, document, e[r], o);
    }), !0;
  }
  return !1;
}
function H(t, n, s, o) {
  if (t === "mousemoveoutside" || t === "clickoutside") {
    const e = i(t, n, s);
    return Object.keys(e).forEach((r) => {
      a(r, document, e[r], o);
    }), !0;
  }
  return !1;
}
export {
  H as trapOff,
  v as trapOn
};
